module.exports = __webpack_public_path__ + "static/media/after-block1.25ec038a.jpg";